import {useMount as _useMount} from 'react-use';

import paths from '@paths';

export const useMount = (isAuthed: string) => {
  _useMount(() => {
    setTimeout(() => {
      if (isAuthed) {
        window.location.href = paths.dashboard.main;
      } else {
        window.location.href = paths.landing.main;
      }
    }, 5000);
  });
};
